import React, { useEffect, useState } from 'react';
import {
  Button,
  Checkbox,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
} from '@material-ui/core';
import { Formik } from 'formik';
import { css } from '@emotion/core';
import * as Yup from 'yup';
import { useRootStore } from '../../../stores/BridgeProvider';
import Spinner from '../../util/Spinner';

const RoleForm = ({ handleSubmission, initialValues }) => {
  const { authStore } = useRootStore();
  const [isLoading, setLoading] = useState(true);
  const [permissions, setPermissions] = useState([]);
  const [selected, setSelected] = useState([]);
  const [change, setChange] = useState(false);

  const Container = css`
    padding: 1rem 0rem;
    .rt-td {
      overflow: visible;
    }
    .role-form {
      min-width: 600px;
      max-width: 1000px;
      margin: 0 auto;
    }
    button {
      margin-top: 1rem;
      width: 100%;
    }
  `;

  const isSelected = name => selected.indexOf(name) !== -1;

  const handleSelectAllClick = event => {
    if (event.target.checked) {
      const newSelecteds = permissions.map(n => n.PermId);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    setChange(true);

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);
  };
  const RoleSchema = Yup.object().shape({
    roleName: Yup.string().required('Required'),
  });

  useEffect(() => {
    const getPermissions = async () => {
      const { data } = await authStore.request.get(
        `${process.env.REACT_APP_API}/api/permissions`,
      );
      setPermissions(data);
    };
    const initialCalls = async () => {
      await Promise.all([getPermissions()]);
      setLoading(false);
      initialValues && setSelected(initialValues.permissions);
    };
    initialCalls();
  }, []);

  useEffect(() => {
    if (initialValues) {
      const initVal = JSON.stringify(initialValues.permissions);
      const sel = JSON.stringify(selected);
      if (sel === initVal) {
        setChange(false);
      }
    }
  }, [selected]);

  return (
    <Formik
      validationSchema={RoleSchema}
      validateOnChange
      initialValues={
        initialValues
          ? {
              roleName: initialValues.roleName,
            }
          : { roleName: '', selected: [] }
      }
      onSubmit={async (values, { setSubmitting }) => {
        try {
          await handleSubmission(values.roleName, selected);
          setSubmitting(false);
        } catch (e) {
          console.error(e);
          setSubmitting(false);
        }
      }}
      render={({
        setFieldValue,
        isSubmitting,
        values,
        handleSubmit,
        isValid,
        errors,
        touched,
        dirty,
      }) => {
        const showError = val => errors[val] && touched[val];

        return (
          <div css={Container}>
            <form className="role-form">
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell align="left" colSpan={2}>
                      <TextField
                        name="roleName"
                        label="Role Name"
                        fullWidth
                        variant="filled"
                        value={values.roleName}
                        onChange={e => {
                          setFieldValue('roleName', e.target.value);
                          setChange(true);
                        }}
                        error={showError('roleName')}
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell padding="checkbox">
                      <Checkbox
                        indeterminate={
                          selected.length > 0 &&
                          selected.length < permissions.length
                        }
                        checked={
                          permissions.length > 0 &&
                          selected.length === permissions.length
                        }
                        onChange={handleSelectAllClick}
                      />
                    </TableCell>
                    <TableCell>Permission</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {permissions.map(permission => {
                    const isItemSelected = isSelected(permission.PermId);

                    return (
                      <TableRow
                        key={permission.PermId}
                        onClick={event => handleClick(event, permission.PermId)}
                        selected={isItemSelected}
                      >
                        <TableCell padding="checkbox">
                          <Checkbox checked={isItemSelected} />
                        </TableCell>
                        <TableCell>{permission.Name}</TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
              <Button
                onClick={handleSubmit}
                color="primary"
                variant="contained"
                disabled={initialValues ? !change : !dirty || isSubmitting}
              >
                Submit
              </Button>
            </form>
          </div>
        );
      }}
    />
  );
};

export default RoleForm;
